
(function () {
    'use strict';

    angular
        .module('kv')
        .directive('comments', comments)
        .directive('rcomments', rcomments)
        .directive('contactComments', contactComments);

    function comments(API, $http, resource, $filter, $uibModal, isAdmin) {
        return {
            templateUrl: "/assets/custom/js/directives/comments/comments.html",
            scope: {
                entityType: '@',
                entityId: '@',
                sourceType: '@',
                sourceTypeId: '@'
            },
            restrict: 'E',
            link: function (scope, element, attributes, controller) {
                var vm = this;
                vm.entity = 'comment';
                vm.primaryKey = 'comment_id';
                scope.$watch("entityId", getComments);

                scope.action = {
                    editComment: editComment,
                    deleteComment: deleteComment
                };

                function deleteComment($index) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: 'modalConfirm',
                        resolve: {
                            content: function() {
                                return $filter("trans")("ARE_YOU_SURE_DELETE");
                            },
                            title: function() {
                                return $filter("trans")("DELETE");
                            }
                        }
                    });

                    modalInstance.result.then(function (response) {
                        if (response === 'cancel') return;

                        const entityType = scope.entityType;
                        const entityId = scope.entityId;
                        const commentId = scope.comments[$index][vm.primaryKey];

                        // DELETE /comments/{model}/{id}/{comment_id}
                        $http.delete('/comments/' + entityType + '/' + entityId + '/' + commentId)
                            .then(function() {
                                scope.comments.splice($index, 1);
                            });
                    });
                }

                function br2nl(str) {
                    return str.replace(/<br\s*\/?>/mg, "\r");
                }

                function editComment($index) {
                    scope.comment = br2nl(scope.comments[$index].comment);
                    scope.comment_id = scope.comments[$index][vm.primaryKey];
                }

                scope.post = function () {
                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    if (scope.comment_id) {
                        // Update existing comment - PUT /comments/{model}/{id}/{comment_id}
                        $http.put('/comments/' + entityType + '/' + entityId + '/' + scope.comment_id, {
                            comment: scope.comment
                        }).then(function () {
                            scope.comment = "";
                            scope.comment_id = null;
                            getComments();
                        });
                    } else {
                        // Create new comment - POST /comments/{model}/{id}
                        $http.post('/comments/' + entityType + '/' + entityId, {
                            comment: scope.comment,
                            entity_type: scope.entityType,
                            entity_id: scope.entityId,
                            source_type: scope.sourceType,
                            source_type_id: scope.sourceTypeId
                        }).then(function () {
                            scope.comment = "";
                            getComments();
                        });
                    }
                };

                function getComments() {
                    scope.isLoading = true;
                    if (!scope.entityId) {
                        scope.isLoading = false;
                        return;
                    }

                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    // GET /comments/{model}/{id}
                    $http.get('/comments/' + entityType + '/' + entityId, {
                        params: {
                            source_type: scope.sourceType,
                            source_type_id: scope.sourceTypeId
                        }
                    })
                        .then(function (res) {
                            var commentsCount = res.data.length;
                            if (commentsCount) {
                                $('a[href="#comments"]').html($filter('trans')('NOTES') + " <span class='badge badge-primary'>" + commentsCount + "<span>");
                            }
                            scope.comments = res.data;
                            scope.isLoading = false;
                        })
                        .catch(function() {
                            scope.isLoading = false;
                        });
                }
            }
        };
    }

    function rcomments(API, $http, resource, $filter, $uibModal) {
        CKEDITOR.config.removePlugins = 'clipboard,colordialog,pastetext,pastefromword,widget,widgetselection,copyformatting,removeformat,tableselection,tabletools,link,list,indentlist,indent,lineutils,sourcearea,scayt,contextmenu,enterkey,maximize,flash,table,horizontalrule,specialchar,blockquote,image,justify,colorbutton,colordialog';
        CKEDITOR.config.disableNativeSpellChecker = true;
        CKEDITOR.config.removeButtons = 'Subscript,Superscript';
        return {
            templateUrl: '/assets/custom/js/directives/comments/rcomments.html?',
            scope: {
                entityType: '@',
                entityId: '@',
                sourceType: '@',
                sourceTypeId: '@',
                attendee: '='
            },
            restrict: 'E',
            link: function (scope, element, attributes, controller, isAdmin) {
                var vm = this;
                vm.entity = 'comment';
                vm.primaryKey = 'comment_id';
                scope.$watch('entityId', getComments);

                scope.post = function () {
                    scope.isLoading = true;
                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    // Create new comment - POST /comments/{model}/{id}
                    $http.post('/comments/' + entityType + '/' + entityId, {
                        comment: scope.comment,
                        entity_type: scope.entityType,
                        entity_id: scope.entityId,
                        source_type: scope.sourceType,
                        source_type_id: scope.sourceTypeId
                    }).then(function () {
                        scope.comment = '';
                        scope.isLoading = false;
                        getComments();
                    });
                };

                function getComments() {
                    scope.isLoading = true;
                    if(!scope.entityId) {
                        scope.comments = [];
                        scope.isLoading = false;
                        return;
                    }

                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    // GET /comments/{model}/{id}
                    $http.get('/comments/' + entityType + '/' + entityId, {
                        params: {
                            source_type: scope.sourceType,
                            source_type_id: scope.sourceTypeId
                        }
                    })
                        .then(function (res) {
                            var commentsCount = res.data.length;
                            if (commentsCount) {
                                $('a[href="#comments"]').html($filter('trans')('NOTES') + ' <span class="badge badge-primary">' + commentsCount + '<span>');
                            }
                            if (scope.attendee) scope.attendee.comment_count = commentsCount;
                            scope.comments = res.data;
                            scope.isLoading = false;
                        })
                        .catch(function() {
                            scope.isLoading = false;
                        });
                }

                scope.action = {
                    editComment: editComment,
                    deleteComment: deleteComment
                };

                function deleteComment($index) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: 'modalConfirm',
                        resolve: {
                            content: function() {
                                return $filter("trans")("ARE_YOU_SURE_DELETE");
                            },
                            title: function() {
                                return $filter("trans")("DELETE");
                            }
                        }
                    });

                    modalInstance.result.then(function (response) {
                        if (response === 'cancel') return;

                        const entityType = scope.entityType;
                        const entityId = scope.entityId;
                        const commentId = scope.comments[$index][vm.primaryKey];

                        // DELETE /comments/{model}/{id}/{comment_id}
                        $http.delete('/comments/' + entityType + '/' + entityId + '/' + commentId)
                            .then(function() {
                                scope.comments.splice($index, 1);
                            });
                    });
                }

                function br2nl(str) {
                    return str.replace(/<br\s*\/?>/mg, "\r");
                }

                function editComment($index) {
                    scope.comment = br2nl(scope.comments[$index].comment);
                    scope.comment_id = scope.comments[$index][vm.primaryKey];
                }
            }
        };
    }

    function contactComments(API, $http, resource, $filter, $uibModal) {
        return {
            templateUrl: "/assets/custom/js/directives/comments/contact-comments.html",
            scope: {
                entityType: '=',
                entityId: '=',
                sourceType: '=',
                sourceTypeId: '='
            },
            restrict: "E",
            link: function (scope, element, attributes, controller, isAdmin) {
                var REST = resource.init('comment');
                scope.$watch("entityId", getComments);

                scope.post = function () {
                    scope.isLoading = true;
                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    // Create new comment - POST /comments/{model}/{id}
                    $http.post('/comments/' + entityType + '/' + entityId, {
                        comment: scope.comment,
                        entity_type: scope.entityType,
                        entity_id: scope.entityId,
                        source_type: scope.sourceType,
                        source_type_id: scope.sourceTypeId
                    }).then(function () {
                        scope.comment = "";
                        scope.isLoading = false;
                        getComments();
                    });
                };

                function getComments() {
                    scope.isLoading = true;
                    if (!scope.entityId) {
                        scope.isLoading = false;
                        return;
                    }

                    const entityType = scope.entityType;
                    const entityId = scope.entityId;

                    // GET /comments/{model}/{id}
                    $http.get('/comments/' + entityType + '/' + entityId)
                        .then(function (res) {
                            var commentsCount = res.data.length;
                            if (commentsCount) {
                                $('a[href="#comments"]').html($filter('trans')('NOTES') + " <span class='badge badge-primary'>" + commentsCount + "<span>");
                            }
                            scope.comments = res.data;
                            angular.forEach(scope.comments, function (v, i) {
                                if (v.scope_type && v.scope_type == 'activity') {
                                    REST.get({
                                        url: 'activity',
                                        params: {
                                            activity_id: v.scope_type_id,
                                        }
                                    }).then(function (data) {
                                        v.activity_name = data.activity_name;
                                        v.activity_id = data.activity_id;
                                    })
                                }
                            });
                            scope.isLoading = false;
                        })
                        .catch(function() {
                            scope.isLoading = false;
                        });
                }

                scope.action = {
                    editComment: editComment,
                    deleteComment: deleteComment
                };

                function deleteComment($index) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        component: 'modalConfirm',
                        resolve: {
                            content: function() {
                                return $filter("trans")("ARE_YOU_SURE_DELETE");
                            },
                            title: function() {
                                return $filter("trans")("DELETE");
                            }
                        }
                    });

                    modalInstance.result.then(function (response) {
                        if (response === 'cancel') return;

                        const entityType = scope.entityType;
                        const entityId = scope.entityId;
                        const commentId = scope.comments[$index].comment_id;

                        // DELETE /comments/{model}/{id}/{comment_id}
                        $http.delete('/comments/' + entityType + '/' + entityId + '/' + commentId)
                            .then(function() {
                                scope.comments.splice($index, 1);
                            });
                    });
                }

                function br2nl(str) {
                    return str.replace(/<br\s*\/?>/mg, "\r");
                }

                function editComment($index) {
                    scope.comment = br2nl(scope.comments[$index].comment);
                    scope.comment_id = scope.comments[$index].comment_id;
                }
            }
        };
    }
})();